export default __webpack_public_path__ + "static/media/purchase-summary-bg-supermin.b3b2285f.jpeg";